export default "__VITE_ASSET__CrpwTpLy__"